<template>
  <input
    ref="input"
    class="field-input__inner form__input"
    :placeholder="placeholder"
    :value="value"
    inputmode="decimal"
    @keypress="inputOnlyNumber"
    @input="onInput"
    @blur="$emit('blur')"
    @focus="() => scrollToEl($refs.input)"
  >
</template>
<script>
import scrollToEl from '../../mixins/scrollToEl';

export default {
  name: 'InputWeight',
  mixins: [scrollToEl],
  props: {
    placeholder: {
      type: String,
      default: 'Вес посылки, кг',
    },
    value: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    inputOnlyNumber(e) {
      const dotIndex = e.target.value.indexOf('.') || e.target.value.indexOf(',');
      const keyCode = (e.keyCode ? e.keyCode : e.which);

      const checkNumber = (keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44; // 46 - точка, 44 - запятая
      const checkDot = dotIndex !== -1 && (keyCode === 46 || keyCode === 44);
      const checkDotLength = dotIndex !== -1 && ((e.target.value.length - dotIndex) > 2);

      if (checkNumber || checkDot || checkDotLength
        || (!e.target.value && (keyCode === 46 || keyCode === 44))) {
        e.preventDefault();
      }
    },
    onInput($event) {
      const value = $event.target.value.replace(',', '.');
      const valueNumber = parseFloat(value);
      if (Number.isNaN(valueNumber)) {
        this.$emit('input', '');
        return;
      }
      this.$emit('input', value);
    },
  },
};
</script>
